<template>
  <div class="loginForm" :class="{ canLogin }">
    <div class="inputBox phone">
      <slot name="p_icon"></slot>
      <input
        v-model="phone"
        type="text"
        @input="phoneChange"
        pattern="\d*"
        placeholder="请输入手机号码"
      />
      <div v-show="phone" @click="phone = ''" class="clear"></div>
    </div>
    <div class="inputBox smsCode" :class="{ canSend }">
      <slot name="s_icon"></slot>
      <input
        v-model="sms_code"
        :maxlength="smsMaxLen"
        type="text"
        pattern="\d*"
        placeholder="请输入短信验证码"
      />
      <div
        @click="getSmsCode"
        class="sms"
        :style="{ color: smsTextColor, backgroundColor: smsBgColor }"
      >
        {{ smsText }}
      </div>
    </div>
    <slot name="agreement"></slot>
    <div @click="login" class="login" :style="{ backgroundColor: btnColor }">
      <slot></slot>
    </div>
    <div class="agree" v-if="showAgree">
      <span
        @click.prevent="toggleAgree"
        :class="{ checked: agree, unchecked: !agree }"
      ></span>
      我已阅读并同意平台<a
        class="pink"
        :href="privacyAndAgree[env]['agree']"
        target="_blank"
      >
        &nbsp;{{ privacyAndAgreeText.agree }}&nbsp;</a
      >及<a
        class="pink"
        :href="privacyAndAgree[env]['privacy']"
        target="_blank"
      >
        &nbsp;{{ privacyAndAgreeText.privacy }}
      </a>
    </div>
  </div>
</template>

<script>
/**
 * Components Usage
 * loginForm组件已在全局注册,
 * 使用时需在自己的login路由对应的组件中使用
 * 例如:
 * login.vue
 * <template>
 *  <loginForm>
 *    登录|| img || div.class
 *  </loginForm>
 * </template>
 * 考虑到活动登陆按钮样式较多,需自行编写登录按钮样式,
 * 编写的按钮html会自动通过slot插入form中
 * 外层绑定了登录按钮的点击事件,所以不需要自己额外定义事件
 * 接收一些参数用于改变验证码按钮背景色和字体颜色:
 * smsBgColor smsTextColor
 */
import {
  // geetestInit,
  setStorage,
  getStorage,
  removeStorage,
  verifyPhone,
  genAccessTokenStr,
  starPhone
} from '@/utils';
import watchdog from '@hll/watch-dog-jsutil';
import { XL_ACCOUNT_TYPE, PRIVACYANDAGREE } from '@/utils/constants';
import { sendEvent } from '@/components/js/watchDog/custom';
import { UNIQUE_ID } from '@/components/js/watchDog/uniqueId';
import { mapState, mapMutations } from 'vuex';
import { CaptchaFactory } from '@xl/captcha-sdk';

const wait = (key, delay = 3000) => {
  let result = false;
  return usage => {
    if (!result) {
      result = true;
      setTimeout(() => {
        result = false;
      }, delay);
      console.log(`⚡⚡⚡⚡⚡---> go excute1 ${key}. ${usage}`);
      return true;
    } else {
      console.log(`⚡⚡⚡⚡⚡---> trigger ${key} more time.${usage}`);
      return false;
    }
  };
};

const smsBtnClickRangeFn = wait('SMS_BTN_CLICK', 3000);

// TODO: 优化

let captchaSDKIns = null;

let sdkInitStartTime = null;
let sdkLoadedTime = null;
let sdkVerifyedTime = null;

/**
 * 前端后门
 * act_verify_type=geetest
 * act_verify_type=netease
 * act_verify_type=nothing
 */

export default {
  props: {
    btnColor: {
      type: String
      // this must no default
    },
    smsBgColor: {
      type: String,
      // this must have default bg color
      default: '#f16622'
    },
    smsTextColor: String,
    loginUrl: String,
    accountType: String
  },
  data() {
    return {
      smsType: null,
      phone: '',
      sms_code: '',
      graphCode: '',
      SMS_RND: '',
      smsHandler: '',
      smsText: '获取验证码',
      graphCodeSrc: null,
      isSmsSending: false, //是否正在发送验证码
      agree: false,
      privacyAndAgree: PRIVACYANDAGREE
    };
  },
  computed: {
    ...mapState('global', ['env', 'ref']),
    // 展示 xl 备案
    showRecord() {
      return this.accountType === XL_ACCOUNT_TYPE;
    },
    canSend() {
      return /^\d{11}$/g.test(this.phone);
    },
    canLogin() {
      return this.phone && this.sms_code;
    },
    smsMaxLen() {
      if (this.env === 'company' || this.accountType === XL_ACCOUNT_TYPE) {
        return 4;
      } else {
        return 6;
      }
    },
    showAgree() {
      return this.accountType === XL_ACCOUNT_TYPE;
    },
    privacyAndAgreeText() {
      let driverContent = {
          privacy: '隐私协议',
          agree: '网约车司机合作协议'
        },
        userContent = {
          privacy: '隐私政策',
          agree: '用户服务协议'
        };
      return this.env == 'user' ? userContent : driverContent;
    }
  },
  async created() {
    console.log(this.env, this.accountType, '123');
    //发短信的随机码
    let SMS_RND = getStorage('SMS_RND');
    if (!SMS_RND) {
      setStorage('SMS_RND', ~~(Math.random() * 900) + 100, 1440000);
    }
    this.SMS_RND = getStorage('SMS_RND');

    await this.captchaSDKInit();
    // this.getSmsType();
  },
  methods: {
    ...mapMutations('global', ['set_env']),
    async captchaSDKInit() {
      try {
        const self = this;
        const captchaFactory = CaptchaFactory.getInstance();
        captchaSDKIns = await captchaFactory.createCaptcha();

        sdkInitStartTime = Date.now();

        captchaSDKIns
          .onLoad(() => {
            sdkLoadedTime = Date.now();
            captchaSDKIns.verify();
          })
          .onVerify(({ type, data }) => {
            sdkVerifyedTime = Date.now();
            sendEvent(
              `${type} captcha from init stage to loaded cost ${sdkLoadedTime -
                sdkInitStartTime}ms, from loaded to verified stage cost ${sdkVerifyedTime -
                sdkLoadedTime}ms`
            );
            self.getTicketAndSendSMS({ type, data });
          })
          .onError(({ type, error }) => {
            self.handleError({ type, error });
          });
      } catch (e) {
        sendEvent('vue人机校验 unknow error:', e.message, e);
        this.$hll.toast('人机校验初始化失败，请重进页面');
      }
    },
    getTicketAndSendSMS({ type, data }) {
      this.sendSmsCode({ type, data });
    },
    handleError() {
      const showToast =
        window.__captcha__config__ && window.__captcha__config__.showErrorToast;
      if (!showToast) return;
      this.$hll.toast('未通过人机校验，请重试');
    },
    phoneChange() {
      if (!this.phoneIsValid()) {
        this.phone = this.phone.replace(/[^0-9]/g, '').slice(0, 11);
      }
    },
    countDown() {
      //验证码倒计时
      let s = 60;
      this.smsText = `发送中(${s}s)`;
      this.isSmsSending = true;
      let timer = setInterval(() => {
        this.smsText = `发送中(${--s}s)`;
        if (s == 0) {
          clearInterval(timer);
          this.smsText = `获取验证码`;
          this.isSmsSending = false;
        }
      }, 1000);
    },
    async getSmsCode() {
      //获取短信验证码
      if (this.isSmsSending) {
        return;
      }
      // 判断手机号是否合法
      if (!this.phoneIsValid()) {
        this.$hll.toast('请输入正确手机号');
        return;
      }
      // 防抖
      const result = smsBtnClickRangeFn('SMS');
      if (!result) return;

      await captchaSDKIns.execute({ phoneNo: this.phone });
    },
    sendSmsCode({ type, data }) {
      let extraParams = {};
      if (type === 'geetest') {
        extraParams = data;
      } else if (type === 'netease') {
        extraParams = {
          netease_validate: data && data.validate
        };
      }

      this.$axios
        .post('/act/passport/send_sms_code', {
          ...extraParams,
          verify_type: type,
          phone_no: this.phone,
          sms_rnd: this.SMS_RND
        })
        .then(data => {
          this.$hll.toast(data.msg);
          this.countDown(); //倒计时
        });
    },

    phoneIsValid() {
      return /^\d{11}$/g.test(this.phone);
    },
    login() {
      let { invitationCode, code } = this.$route.params.redirectObject || {};
      // 小拉用户需要设置 同意协议
      if (this.showAgree) {
        if (!this.agree) {
          this.$hll.toast('请勾选协议');
          return;
        }
      }

      //登录
      if (!this.canLogin) {
        this.$hll.toast('请填写手机号和验证码');
        return;
      }

      let url = this.loginUrl ? this.loginUrl : '/act/passport/phone_in';
      if (verifyPhone(this.phone)) {
        this.$axios
          .post(url, {
            phone_no: this.phone,
            sms_code: this.sms_code,
            code,
            invitationCode,
            sms_rnd: this.SMS_RND,
            user_type: this.env
          })
          .then(e => {
            try {
              this.$sensors.login(e.hash_fid);
            } catch (err) {
              console.log(err);
              sendEvent('LOGIN_SENSOR_ERROR', err);
            }
            try {
              if (this.accountType === XL_ACCOUNT_TYPE) {
                this.visitLog('', '', {
                  actEventType: 'login_success',
                  url: location.href
                });
              }
              if (
                this.accountType === XL_ACCOUNT_TYPE &&
                this.env === 'user' &&
                e.newUser
              ) {
                this.visitLog('', '', {
                  actEventType: 'register_success',
                  web_url: location.href
                });
              }
            } catch (err) {
              console.log(err);
            }
            if (e.user_type) {
              this.set_env(e.user_type);
              setStorage(`act_user_type`, e.user_type);
            } else {
              removeStorage(`act_user_type`);
            }
            // different key by account type
            setStorage(genAccessTokenStr(this.accountType), e.access_token);
            sessionStorage.setItem('loged', '1'); // 存储登录状态
            sessionStorage.setItem('__mobile__', this.phone); // 存储手机号
            this.$emit('loged', true); //回调
            watchdog.setConfig({
              bizUserId: JSON.stringify({
                userId: e.hash_fid,
                uniqueId: UNIQUE_ID
              })
            });
            if (this.$route.params && this.$route.params.redirectObject) {
              this.$router.replace(this.$route.params.redirectObject);
            } else {
              this.$router.replace(`/`);
            }
          })
          .catch(e => {
            this.$emit('loged', false); //回调
            sendEvent('LOGIN_FORM_FAILED_ERROR', e, {
              phone: starPhone(this.phone),
              code: this.sms_code
            });

            if (e.ret == 8008) {
              setTimeout(() => {
                location.href = `https://dappweb.huolala.cn/driver-join/?ref=${this
                  .ref || 'act2_common_login'}`;
              }, 2000);
            }
          });
      }
    },
    toggleAgree() {
      this.agree = !this.agree;
    }
  }
};
</script>

<style lang="less" scoped>
.loginForm {
  flex-shrink: 0;
  margin-top: 625px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > div {
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
    padding: 0 10px;
    box-sizing: border-box;
    width: 617px;
    height: 96px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 10px;

    input {
      flex: 1;
      padding: 20px 0;
      box-sizing: border-box;
    }
  }

  & > .agree {
    justify-content: flex-start;
    // align-items: flex-start;
    font-size: 22px;
    // margin-top: 40px; // 96

    & > .checked {
      width: 30px;
      height: 30px;
      background: center / 21px 21px url('../assets/common/checked.png')
        no-repeat;
    }

    & > .unchecked {
      width: 30px;
      height: 30px;
      // background-size: ;
      background: center / 21px 21px url('../assets/common/no_check.png')
        no-repeat;
    }

    .pink {
      color: #ff4553;
    }
  }

  .sms {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 175px;
    height: 76px;
    border-radius: 10px;
    font-size: 24px;
    font-weight: 300;
    color: rgba(242, 242, 242, 1);
  }

  .img-code {
    img.code-image {
      height: 67px;
      width: auto;
    }
  }

  .clear {
    width: 32px;
    height: 32px;
    background-size: 100% 100%;
    background-image: url(../assets/common/ic_clear.png);
  }

  .login {
    margin-top: 35px;
    justify-content: center;
    min-width: 624px;
    min-height: 96px;
    border-radius: 4px;
    font-size: 32px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background-color: transparent;

    * {
      flex-shrink: 0;
    }
  }
}

.smsCode {
  position: relative;

  .sms {
    position: absolute;
    right: 0;
    width: 176px;
    height: 72px;
    opacity: 0.2;
    border-radius: 4px;
    background-color: #f16622;
  }

  &.canSend {
    .sms {
      background-color: #f16622;
      opacity: 1;
    }
  }
}
</style>
